import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule,ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';

import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { AgencyreportComponent } from './agencyreport.component';
import { MyDatePickerModule } from 'mydatepicker';
import { AgencyreportRoutingModule } from './agencyreport-routing.module';
import { AgencyreportdataService } from './agencyreportdata.service';
import { AgencyreportService } from './agencyreport.service';

@NgModule({
  declarations: [AgencyreportComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgxUiLoaderModule,
    MyDatePickerModule,
    MaskedTextBoxModule,
    AgencyreportRoutingModule
  ],
  providers: [ColumnChooserService,PageService,SortService,FilterService, ResizeService,AgencyreportdataService,AgencyreportService],
})
export class AgencyreportModule { }
